import { IInputStatus } from '../../../interface/progress.interface'
import { IChangeValue } from '../../../interface/steps.interface'
import { IStringInputSettings } from '../inputs.interface'
import String from '../String/String'
import { useBankAccount } from './useBankAccount'
import { Info } from '../../../assets/Info'
import styles from './BankAccount.module.scss'
// import { CheckBox } from '../../../assets/checkbox'
import { useEffect } from 'react'

interface Props {
  value: string
  name: string
  handleChange: IChangeValue
  status: IInputStatus
  settings: IStringInputSettings
  apiErrors: { [name: string]: string }
  isIbanCheckbox?: boolean
  changeIbanCheckbox?: Function
  progressTrigger?: Function
  tooltip?: string
}

const BankAccount = ({
  value,
  name,
  handleChange,
  status,
  settings,
  apiErrors,
  isIbanCheckbox,
  changeIbanCheckbox,
  progressTrigger,
  tooltip
}: Props) => {
  // const status = IInputStatus.error
  const {
    localValue,
    localStatus,
    inputRef,
    disabled,
    localSettings,
    handleLocalChange,
    handleKeydown,
    handlePaste,
    handleFocus,
    handleBlur,
    substitution
  } = useBankAccount({
    value,
    name,
    handleChange,
    status,
    settings,
    progressTrigger
  })

  useEffect(() => {
  }, [status])

  return (
    <>
      <div className={styles.wrapper}>
        <String
          value={localValue}
          name={name}
          status={localStatus}
          disabled={disabled}
          apiErrors={apiErrors}
          innerRef={inputRef}
          settings={localSettings}
          handleChange={handleLocalChange}
          handleKeydown={handleKeydown}
          handlePaste={handlePaste}
          handleFocus={handleFocus}
          handleBlur={handleBlur}
          width='560px'
          substitution={substitution}
          tooltip={tooltip}
          isBank={true}
        />
      </div>
      <div className={styles.checkbox}>
        <div className={styles.check_wrapper}>
          <div className={styles.check_input}>
            <input
              className={styles.checkbox}
              type="checkbox"
              id='ibanCheckbox'
              //@ts-ignore
              onChange={changeIbanCheckbox || (() => { })}
              defaultChecked={isIbanCheckbox}
            />
            <label className={styles.label} htmlFor='ibanCheckbox'>
              Transferencia inmediata
            </label>

          </div>
        </div>
        {/* <CheckBox /> */}
        {/* <img src={Checkbox} /> */}
        {/* <span>
          Transferencia inmediata
        </span> */}
      </div>
      <div className={styles.info}>
        <Info />
        {/* <img src={Info} /> */}
        <span>¡Atención! No cargaremos ningún importe en tu cuenta. La verificación es totalmente gratuita.</span>
      </div>
    </>
  )
}

export default BankAccount
